import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject;
import styled from 'styled-components';
import { get } from '../../styles/constant';
const HintText = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  padding: ", " 0 0 0;\n  color: ", ";\n  font-size: ", ";\n  line-height: ", ";\n  text-align: ", ";\n"])), get('space.4'), get('colors.functional.grey.600'), get('fontSizes.14'), get('lineHeights.20'), props => props.hintPosition === 'right' ? 'right' : 'left');
const Components = {
  HintText
};
export { Components };